/* NPM */
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
/* UTILS */
import useAppContext from "../AppContext";
import routes from "../../routes";
import { getPreviousPage } from "../../utils/branching";
/* ASSETS */
import Chevron from "./assets/Chevron";
import weightWatchersClinic from "./assets/weightWatchersClinic.svg";
/* STYLES */
import styles from "./styles.module.scss";

const SequenceProgressBar = ({ backButtonProps, question, hideBack }) => {
  const { onBack, ...otherBackProps } = backButtonProps || {};
  const { questionNumber, totalQuestionsInSection } = question || {};

  const { authData, answers, assessment } = useAppContext();

  const history = useHistory();

  const isFirst = useMemo(
    () => question?.tags?.includes("first"),
    [question?.tags]
  );

  const value = useMemo(() => {
    const percentage = questionNumber / totalQuestionsInSection;
    if (percentage <= 0.03) {
      return 0.03;
    }

    return percentage;
  }, [questionNumber, totalQuestionsInSection]);

  const handleBack = () => {
    const from = getPreviousPage(answers, assessment);
    if (
      authData.loggedInAs &&
      from === routes.createAccount?.replace(/\//gi, "") &&
      history.location.pathname === routes.state
    ) {
      history.go(-2);
    } else {
      onBack();
    }
  };

  const renderTitle = () => {
    if (hideBack || history.location.pathname === routes.state) {
      return null;
    }

    if (isFirst) {
      return (
        <img
          className={styles.clinicTitleImage}
          aria-label="Weight Watcher Clinic Title"
          src={weightWatchersClinic}
        />
      );
    }

    return (
      <button
        onClick={handleBack}
        className={styles.clinicBackButton}
        {...otherBackProps}
      >
        <Chevron />
      </button>
    );
  };

  return (
    <div className={styles.clinicTitle}>
      {renderTitle()}
      <div className={styles.progressBarContainer}>
        <div className={styles.fill} style={{ width: `${value * 100}%` }} />
      </div>
    </div>
  );
};

export default SequenceProgressBar;
